<template>
  <div class="col-12">
    <!-- <pre>{{ rows }}</pre> -->
    <div class="card hovers">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 d-flex gap-2">
            <div class="d-flex flex-column justify-content-center">
              <label>
                <input type="checkbox" v-model="rows.selected" :value="rows" />
              </label>
            </div>
            <div
              style="cursor: pointer"
              class="ml-2"
              @click="
                $router.push('/message_report/broadcast/info?id=' + rows.id)
              "
            >
              <h5 :title="rows.title">
                {{
                  rows.title.length > 20
                    ? rows.title.slice(0, 20) + "..."
                    : rows.title
                }}
              </h5>
              <div class="" ref="license">
                <Skeleton :count="1" />
              </div>
              <small class="text-muted">
                Last Update : {{ formatLocalDate(rows.update_datetime)  }}
              </small>
              <div class="">
                <template v-if="rows.is_send == 0">
                  <span :class="'text text-warning'">
                    <i class="fa fa-pause"></i>
                    DRAFT
                  </span>
                </template>
                <template v-if="rows.is_send == 1">
                  <span
                    :class="'text text-success'"
                    v-if="rows.sending_options == 1"
                  >
                    <i class="fa fa-check"></i>
                    SENT
                    <br />
                    <small v-if="rows.cron_timestamp > 0">{{
                      formatLocalDateWithDay(rows.cron_timestamp)
                    }}</small>
                    <small v-else>
                      {{ formatLocalDateWithDay(rows.update_datetime) }}
                      <br />(send now)
                    </small>
                  </span>
                  <span
                    :class="'text text-success'"
                    v-if="
                      rows.sending_options == 2 &&
                      rows.sending_schedule < currentDateTimeUnix()
                    "
                  >
                    <i class="fa fa-check"></i>
                    Sent
                    <br />
                    <small>{{
                      formatLocalDateWithDay(rows.cron_timestamp)
                    }}</small>
                  </span>
                  <span
                    :class="'text text-info'"
                    v-if="
                      rows.sending_options == 2 &&
                      rows.sending_schedule > currentDateTimeUnix()
                    "
                  >
                    <i class="fa fa-clock-o"></i>
                    Scheduled
                    <br />
                    <small>{{
                      formatLocalDateWithDay(rows.sending_schedule)
                    }}</small>
                  </span>
                </template>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-0">
            <div class=" d-none d-md-block">
                <div
                  class="row d-flex flex-column flex-md-row justify-content-between"
                >
                  <div class="d-flex flex-md-column">
                    <div class="font-weight-bold">Recipients</div>
                    <div>{{ rows.destination_num }}</div>
                  </div>
                  <div class="d-flex flex-md-column">
                    <div class="font-weight-bold">Waiting</div>
                    <div>{{ rows.pending_num }}</div>
                  </div>
                  <div class="d-flex flex-md-column">
                    <div class="font-weight-bold">Error</div>
                    <div class="text-center">
                      <router-link
                        :to="{
                          path: '/message_report/broadcast_prepare',
                          query: { broadcast_id: rows.id, status: 'failed' },
                        }"
                        :class="'badge badge-danger'"
                        >{{ rows.error_num }}</router-link
                      >
                    </div>
                  </div>
                  <div class="d-flex flex-md-column">
                    <div class="font-weight-bold">Success</div>
                    <div class="text-center">
                      <router-link
                        :to="{
                          path: '/message_report/broadcast_prepare',
                          query: { broadcast_id: rows.id, status: 'executed' },
                        }"
                        :class="'badge badge-success'"
                        >{{ rows.success_num }}</router-link
                      >
                    </div>
                  </div>
                </div>
            </div>
            <div class="ml-3 ml-md-0 mt-3">
              <template v-if="rows.is_recurring == 1">
                <i class="fa fa-clock-o"></i>
                {{ rows.recurrence }}
                <span>
                  <br />
                  time:
                  {{
                    formatHourFromUnix(
                      convertUTCDatetimeToUnix(rows.recurrence_time)
                    )
                  }}
                </span>
                <span v-if="rows.recurrence != 'daily'">
                  <br />
                  every: {{ rows.recurrence_every }}
                  {{ rows.recurrence_annually_month }}
                </span>

                <br />end:
                <span v-if="rows.recurrence_end == 'never'">{{
                  rows.recurrence_end
                }}</span>
                <span v-else>{{
                  formatLocalDate(rows.recurrence_end_date)
                }}</span>
              </template>
            </div>
          </div>
          <div class="col-md-2 text-right">
            <a-popover
              class="d-inline-block d-md-none"
              title="Summary"
              trigger="focus"
            >
              <template slot="content">
                <div
                  class="row d-flex flex-column flex-md-row justify-content-between mx-2"
                >
                  <div class="d-flex flex-md-column justify-content-between">
                    <div class="font-weight-bold">Recipients</div>
                    <div>{{ rows.destination_num }}</div>
                  </div>
                  <div class="d-flex flex-md-column justify-content-between">
                    <div class="font-weight-bold">Waiting</div>
                    <div>{{ rows.pending_num }}</div>
                  </div>
                  <div class="d-flex flex-md-column justify-content-between">
                    <div class="font-weight-bold">Error</div>
                    <div class="badge badge-danger">
                      <router-link
                        :to="{
                          path: '/message_report/broadcast_prepare',
                          query: { broadcast_id: rows.id, status: 'failed' },
                        }"
                        :class="'badge badge-danger'"
                        >{{ rows.error_num }}</router-link
                      >
                    </div>
                  </div>
                  <div class="d-flex flex-md-column justify-content-between">
                    <div class="font-weight-bold">Success</div>
                    <div class="badge badge-success">
                      <router-link
                        :to="{
                          path: '/message_report/broadcast_prepare',
                          query: { broadcast_id: rows.id, status: 'executed' },
                        }"
                        :class="'badge badge-success'"
                        >{{ rows.success_num }}</router-link
                      >
                    </div>
                  </div>
                </div>
              </template>
              <button type="button" class="btn btn-white btn-sm btn-rounded">
                <i class="fa fa-line-chart text-info"></i>
              </button>
            </a-popover>

            <div class="dropdown action-label">
              <a
                class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                href="#"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa fa-dot-circle-o text-danger"></i> Options
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <router-link
                  :to="'/message_report/broadcast/info?id=' + rows.id"
                  class="dropdown-item"
                >
                  <i class="fa fa-eye text-success"></i> Detail
                </router-link>
                <router-link
                  :to="'/message_report/broadcast/wizard?id=' + rows.id"
                  class="dropdown-item"
                  v-if="rows.is_send == '0' && rows.is_import == '0'"
                >
                  <i class="fa fa-pencil text-success"></i> Edit
                </router-link>
                <router-link
                  v-if="rows.is_import == '0'"
                  :to="
                    '/message_report/broadcast/wizard?id=' + rows.id + '&copy=1'
                  "
                  class="dropdown-item"
                >
                  <i class="fa fa-copy text-success"></i> Duplicate
                </router-link>
                <a
                  @click.prevent="$emit('deleteBroadcast', rows.id)"
                  class="dropdown-item"
                >
                  <i class="fa fa-trash-o text-danger"></i> Remove
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid,
  convertUTCDatetimeToUnix,
  formatHourFromUnix,
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
export default {
  name: "broadcast-card",
  components: {
    Skeleton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    selectedTable: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rows: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    console.log("item created");
  },
  mounted(){
    this.getLicenseById(this.rows.license_id);

  },
  methods: {
    formatLocalDate(val) {
      return formatLocalDate(val);
    },
    convertUTCDatetimeToUnix(val) {
      return convertUTCDatetimeToUnix(val);
    },
    formatHourFromUnix(val) {
      return formatHourFromUnix(val);
    },
    formatLocalDateWithDay(val) {
      return formatLocalDateWithDay(val);
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    getLicenseById(id) {
      this.$store.dispatch("license/getLicenseById", id).then((resLic) => {
        var dataLic = resLic.data;
        // console.log("dataLic", dataLic);
        this.$refs["license"].innerHTML =
          "<b>" +
          dataLic.license_name +
          '</b><br /><span class="text-muted">' +
          dataLic.license_phone_number +
          "</span>";
      }); // sesuai kan dengan method di API
    },
  },
};
</script>

<style>
.hovers {
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */
  /* transform: translateY(-2px); */
}
.hovers:hover {
  box-shadow: 0 1px 16px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/views/messageReport/v2/broadcast-card.vue